import React, { useEffect, useState } from 'react';

const Counter = ({ start, end, duration, isVisible }) => {
  const [count, setCount] = useState(start);

  useEffect(() => {
    if (!isVisible) return;

    // Calculate the interval based on the duration
    const increment = (end - start) / (duration / 20); // Increment by a fraction
    let currentCount = start;
    const interval = setInterval(() => {
      currentCount += increment;
      if (currentCount >= end) {
        setCount(end);
        clearInterval(interval); // Stop the interval when the end is reached
      } else {
        setCount(Math.floor(currentCount)); // Set the updated count
      }
    }, 50); // Update every 50 milliseconds

    // Clean up the interval on component unmount
    return () => clearInterval(interval);
  }, [start, end, duration, isVisible]);

  // Format the number with commas (e.g., 1,000,000)
  const formattedCount = new Intl.NumberFormat().format(count);

  return (
    <div className="counter">
      <span>{formattedCount}</span>
    </div>
  );
};

export default Counter;
